module.exports = __webpack_public_path__ + "static/media/magic-mushrooms.36227c58.jpg";